import React from "react";
import { Features} from "../../Pages/FeaturesPage/Features"

function FeaturesPage() {
  return <div>
    < Features />
  </div>;
}

export { FeaturesPage };
